// extracted by mini-css-extract-plugin
export default {"container":"Container_container__QMI3r","mobile":"Container_mobile__Jw9fm"};